import { Avatar, Card, CardContent, CardHeader, Container, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

const Profile: React.FC = () => {
  const profile = useSelector((state: RootState) => state.auth.profile);

  return (
    <Container sx={{ mt: 4 }}>
      <Grid container justifyContent="center" spacing={2}>
        <Grid size={12}>
          <Card sx={{ p: 2 }}>
            <CardHeader avatar={<Avatar>{profile?.firstName.charAt(0)}</Avatar>} title="Mon Profil" titleTypographyProps={{ variant: 'h5' }} />
            <CardContent>
              <Grid container spacing={2}>
                <Grid size={12}>
                  <Typography variant="body1">
                    <strong>ID:</strong> {profile?.id}
                  </Typography>
                </Grid>
                <Grid size={12}>
                  <Typography variant="body1">
                    <strong>Email:</strong> {profile?.email}
                  </Typography>
                </Grid>
                <Grid size={12}>
                  <Typography variant="body1">
                    <strong>Prénom:</strong> {profile?.firstName}
                  </Typography>
                </Grid>
                <Grid size={12}>
                  <Typography variant="body1">
                    <strong>Nom:</strong> {profile?.lastName}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Profile;
